export default __webpack_public_path__ + "static/media/portfolio.a9c8b708.png";